export default __webpack_public_path__ + "static/media/facebook.c6ae7188.svg";